(() => {
  let isNormalizingGiftwrapQuantity = false;

  const getCartDrawer = () => document.querySelector('cart-drawer');
  const getCartError = () => document.getElementById('CartDrawer-CartErrors');

  const setCartError = (message) => {
    const errorContainer = getCartError();
    if (errorContainer) errorContainer.textContent = message || 'Unable to add this item. Please try again.';
  };

  const clearCartError = () => {
    const errorContainer = getCartError();
    if (errorContainer) errorContainer.textContent = '';
  };

  const appendSections = (body, cartDrawer) => {
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return;

    const sections = cartDrawer.getSectionsToRender().map((section) => section.id);

    if (body instanceof FormData) {
      body.append('sections', sections);
      body.append('sections_url', window.location.pathname);
      return;
    }

    body.sections = sections;
    body.sections_url = window.location.pathname;
  };

  const syncEmptyState = (cartDrawer, parsedState) => {
    if (!cartDrawer || typeof parsedState?.item_count !== 'number') return;

    cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
  };

  const normalizeGiftwrapQuantity = async () => {
    if (isNormalizingGiftwrapQuantity) return;

    const staleGiftwrapLine = Array.from(document.querySelectorAll('[data-hm-giftwrap-line][data-line-key]'))
      .find((line) => Number(line.dataset.quantity) !== 1);

    if (!staleGiftwrapLine) return;

    const lineKey = staleGiftwrapLine.dataset.lineKey;
    if (!lineKey) return;

    const cartDrawer = getCartDrawer();
    const body = { id: lineKey, quantity: 1 };
    const config = fetchConfig('javascript');

    appendSections(body, cartDrawer);
    config.body = JSON.stringify(body);
    isNormalizingGiftwrapQuantity = true;

    try {
      const response = await fetch(window.routes.cart_change_url, config);
      const parsedState = await response.json();
      await renderCart(cartDrawer, parsedState, 'hm-cart-giftwrap-normalize');
    } catch (error) {
      console.error(error);
      setCartError(error.shopperMessage || 'Unable to update gift wrap. Please try again.');
    } finally {
      isNormalizingGiftwrapQuantity = false;
    }
  };

  const renderCart = async (cartDrawer, parsedState, source, variantId) => {
    if (parsedState.status) {
      const message = parsedState.description || parsedState.message || 'Unable to add this item. Please try again.';

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, {
          source,
          productVariantId: variantId,
          errors: parsedState.errors || parsedState.description,
          message: parsedState.message,
        });
      }

      setCartError(message);
      const error = new Error(message);
      error.shopperMessage = message;
      throw error;
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      await publish(PUB_SUB_EVENTS.cartUpdate, {
        source,
        productVariantId: variantId,
        cartData: parsedState,
      });
    }

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(parsedState);
    }
    syncEmptyState(cartDrawer, parsedState);

    clearCartError();
    await normalizeGiftwrapQuantity();
  };

  const refreshCartDrawer = async () => {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return;

    const sections = cartDrawer.getSectionsToRender();

    try {
      const response = await fetch(`${window.routes.cart_url}?sections=${sections.map((section) => section.id).join(',')}`, {
        cache: 'no-store',
      });
      const parsedSections = await response.json();

      sections.forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (sectionElement) {
          sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(parsedSections[section.id], section.selector);
        }
      });

      cartDrawer.classList.toggle(
        'is-empty',
        cartDrawer.getSectionDOM(parsedSections['cart-drawer'], 'cart-drawer').classList.contains('is-empty')
      );
      cartDrawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', cartDrawer.close.bind(cartDrawer));
    } catch (error) {
      console.error(error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeGiftwrapQuantity);
  } else {
    normalizeGiftwrapQuantity();
  }

  // Back/forward (e.g. leaving checkout) can show this page from cache with the cart as it was at first load;
  // requests made during that load may be served from cache too, hence no-store above.
  window.addEventListener('pageshow', (event) => {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (event.persisted || navigation?.type === 'back_forward') refreshCartDrawer();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-hm-cart-async-add]');
    if (!form) return;

    event.preventDefault();

    const cartDrawer = getCartDrawer();
    const button = form.querySelector('button[type="submit"]');
    if (button?.getAttribute('aria-disabled') === 'true') return;

    const spinner = button?.querySelector('.loading__spinner');
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const config = fetchConfig('javascript');

    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    appendSections(formData, cartDrawer);
    config.body = formData;

    clearCartError();
    button?.setAttribute('aria-disabled', 'true');
    button?.classList.add('loading');
    spinner?.classList.remove('hidden');

    try {
      const response = await fetch(window.routes.cart_add_url, config);
      const parsedState = await response.json();
      await renderCart(cartDrawer, parsedState, 'hm-cart-crosssell', variantId);
    } catch (error) {
      console.error(error);
      setCartError(error.shopperMessage);
    } finally {
      button?.removeAttribute('aria-disabled');
      button?.classList.remove('loading');
      spinner?.classList.add('hidden');
    }
  });

  document.addEventListener('change', async (event) => {
    const toggle = event.target.closest('[data-hm-giftwrap-toggle]');
    if (!toggle) return;

    const cartDrawer = getCartDrawer();
    const checked = toggle.checked;
    const variantId = toggle.dataset.addVariantId;
    const lineKey = toggle.dataset.lineKey;
    const isChangingExistingGiftwrap = Boolean(lineKey);

    if (!checked && !isChangingExistingGiftwrap) {
      toggle.checked = true;
      setCartError('Unable to remove gift wrap because it is not in your cart. Please refresh and try again.');
      return;
    }

    if (checked && !isChangingExistingGiftwrap && !variantId) {
      toggle.checked = false;
      setCartError('Unable to add gift wrap. Please refresh and try again.');
      return;
    }

    const body = checked && !isChangingExistingGiftwrap
      ? { id: Number(variantId), quantity: 1 }
      : { id: lineKey, quantity: checked ? 1 : 0 };
    const url = checked && !isChangingExistingGiftwrap ? window.routes.cart_add_url : window.routes.cart_change_url;
    const config = fetchConfig('javascript');

    appendSections(body, cartDrawer);
    config.body = JSON.stringify(body);
    clearCartError();
    toggle.disabled = true;

    try {
      const response = await fetch(url, config);
      const parsedState = await response.json();
      await renderCart(cartDrawer, parsedState, 'hm-cart-giftwrap', variantId);
    } catch (error) {
      console.error(error);
      toggle.checked = !checked;
      setCartError(error.shopperMessage || 'Unable to update gift wrap. Please try again.');
    } finally {
      toggle.disabled = false;
    }
  });
})();
